import { useEffect } from 'react';

export default function usePageMeta(title, description) {
  useEffect(() => {
    const baseTitle = 'Gabriele Denaro';
    document.title = title ? `${title} | ${baseTitle}` : `${baseTitle} - Analista e Investitore Value`;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute('content', description);
    }
  }, [title, description]);
}
